import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import CorreosClassic from './CorreosClassic';
import CorreosGmail from './CorreosGmail';

/**
 * Dispatcher `/correos`. Lee `prefs.vista_correos_gmail` del usuario y
 * renderiza la vista Gmail-style (split panel) o la clásica (modal).
 *
 * El toggle vive en `/perfil → Preferencias IA Correo`.
 */
export default function Correos() {
  const [mode, setMode] = useState(null); // null=loading, 'gmail'|'classic'

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me/prefs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (r.ok) {
          const p = await r.json();
          if (!cancel) setMode(p.vista_correos_gmail === false ? 'classic' : 'gmail');
        } else if (!cancel) {
          setMode('gmail'); // default
        }
      } catch (_) {
        if (!cancel) setMode('gmail');
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (mode === null) {
    return (
      <div className="py-20 text-center" data-testid="correos-loading-prefs">
        <Loader2 className="w-6 h-6 animate-spin text-brand-600 mx-auto" />
      </div>
    );
  }
  return mode === 'gmail' ? <CorreosGmail /> : <CorreosClassic />;
}
